import config from '../nyConfig'
const ApiDemand = {
    "需求信息审核列表": new config({url: '/demand/auditing/pageDemand', showSuccessMessage: false, useToken: true }),
    "需求信息审核列表统计": new config({url: '/demand/auditing/countDemand', showSuccessMessage: false, useToken: true }),
    "需求信息详情": new config({url: '/demand/auditing/demandInfo', showSuccessMessage: false, useToken: true }),
    "修改需求基本信息": new config({url: '/demand/auditing/updateBaseInfo', showSuccessMessage: true, useToken: true }),
    "修改需求位置": new config({url: '/demand/auditing/updateAddressInfo', showSuccessMessage: true, useToken: true }),
    "修改需求联系人": new config({url: '/demand/auditing/updateContactsInfo', showSuccessMessage: true, useToken: true }),
    "需求审核通过": new config({url: '/demand/auditing/passAuditing', showSuccessMessage: true, useToken: true }),
    "需求审核拒绝": new config({url: '/demand/auditing/refuseAuditing', showSuccessMessage: true, useToken: true }),
    "需求暂停/继续发布": new config({url: '/demand/auditing/operationLand', showSuccessMessage: true, useToken: true }),
    "需求批量下架": new config({url: '/demand/auditing/batchDeList', showSuccessMessage: true, useToken: true }),
}

export default ApiDemand
